import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 前台路由
  {
    path: '/',
    component: () => import('@/layouts/FrontLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/pages/Home.vue')
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/pages/About.vue')
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/pages/News.vue')
      },
      {
        path: 'news/:id',
        name: 'NewsDetail',
        component: () => import('@/pages/NewsDetail.vue')
      },
      {
        path: 'services',
        name: 'Services',
        component: () => import('@/pages/Services.vue')
      },
      {
        path: 'advantages',
        name: 'Advantages',
        component: () => import('@/pages/Advantages.vue')
      },
      {
        path: 'qualifications',
        name: 'Qualifications',
        component: () => import('@/pages/Qualifications.vue')
      },
      {
        path: 'careers',
        name: 'Careers',
        component: () => import('@/pages/Careers.vue')
      },
      {
        path: 'projects',
        name: 'Projects',
        component: () => import('@/pages/Projects.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/pages/Contact.vue')
      }
    ]
  },
  // 后台路由
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/pages/admin/SSOLogin.vue')
  },
  {
    path: '/admin/sso-login',
    name: 'AdminSSOLogin',
    component: () => import('@/pages/admin/SSOLogin.vue')
  },
  {
    path: '/admin/sso-callback',
    name: 'AdminSSOCallback',
    component: () => import('@/pages/admin/SSOCallback.vue')
  },
  {
    path: '/admin/sso-success',
    name: 'AdminSSOSuccess',
    component: () => import('@/pages/admin/SSOCallback.vue')
  },
  {
    path: '/admin/sso-error',
    name: 'AdminSSOError',
    component: () => import('@/pages/admin/SSOError.vue')
  },
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import('@/pages/admin/Dashboard.vue')
      },
      {
        path: 'pages',
        name: 'AdminPages',
        component: () => import('@/pages/admin/Pages.vue')
      },
      {
        path: 'stats',
        name: 'AdminStats',
        component: () => import('@/pages/admin/PageStats.vue')
      },
      {
        path: 'news',
        name: 'AdminNews',
        component: () => import('@/pages/admin/News.vue')
      },
      {
        path: 'carousels',
        name: 'AdminCarousels',
        component: () => import('@/pages/admin/Carousels.vue')
      },
      {
        path: 'services',
        name: 'AdminServices',
        component: () => import('@/pages/admin/Services.vue')
      },
      {
        path: 'advantages',
        name: 'AdminAdvantages',
        component: () => import('@/pages/admin/Advantages.vue')
      },
      {
        path: 'qualifications',
        name: 'AdminQualifications',
        component: () => import('@/pages/admin/Qualifications.vue')
      },
      {
        path: 'projects',
        name: 'AdminProjects',
        component: () => import('@/pages/admin/Projects.vue')
      },
      {
        path: 'careers',
        name: 'AdminCareers',
        component: () => import('@/pages/admin/Careers.vue')
      },
      {
        path: 'images',
        name: 'AdminImages',
        component: () => import('@/pages/admin/Images.vue')
      },
      {
        path: 'partners',
        name: 'AdminPartners',
        component: () => import('@/pages/admin/Partners.vue')
      },
      {
        path: 'backup',
        name: 'AdminBackup',
        component: () => import('@/pages/admin/Backup.vue')
      },
      {
        path: 'change-password',
        name: 'AdminChangePassword',
        component: () => import('@/pages/admin/ChangePassword.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/admin/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
